export {
    ViewHomepageResource as default,
    searchComponentVirtualAgentResource,
    getSearchComponentVirtualAgentResource,
} from './resources';
